import { Utilities as utilities } from "@truckdown/framework";

export class GetRangesModel {
    constructor(json?: any) {
        this.filter = utilities.json.getStringValue(json, 'filter');
        this.lastId = utilities.json.getStringValue(json, 'lastId');
        this.lastIpAddressStart = utilities.json.getStringValue(json, 'lastIps');
        this.take = utilities.json.getNumberValue(json, 'take', 15);
    }

    toJSON() {
        return {
            filter: this.filter,
            lastId: this.lastId,
            lastIps: this.lastIpAddressStart,
            take: this.take
        };
    }

    filter: string | null = null;
    lastId: string | null = null;
    lastIpAddressStart: string | null = null;
    take: number = 15;
}